import React from 'react';
import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';
import { RenderRetailTableActionButtons } from '../../commons/tableActionButton/tableActionButton';
import { getFormattedDateAndTime } from '../../../services/helpers';
import download from '../../../assets/images/download-theme.svg';
import {
  retryFailedCns,
  createPartialDummyPrs
} from './bulkCnUsingExcelRedux/bulkCnUsingExcelActionCreator';

export const bulkCnUsingExcelConfig = {
  columns: [
    {
      Header: 'Request Id',
      headerClassName: 'zt-custom-th flex-25',
      className: 'zt-custom-td flex-25',
      accessor: 'requestId',
      Cell: row => (
        <div className="l-row a-center">{row.original.requestId || '-'}</div>
      )
    },
    {
      Header: 'Created By',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      Cell: row => row.original.createdBy || '-'
    },
    {
      Header: 'Created At',
      headerClassName: 'flex-15 zt-custom-th',
      className: 'zt-custom-td flex-15',
      Cell: row => {
        return (
          <div>
            {row.original.createdAt
              ? getFormattedDateAndTime(row.original.createdAt)
              : '-'}
          </div>
        );
      }
    },
    {
      Header: 'Total Rows(Success, Success Pending, Failure)',
      headerClassName: 'flex-30 zt-custom-th',
      className: 'zt-custom-td flex-30',
      Cell: row => {
        let statusArray = [];

        if (!row.original.statusWiseCount) {
          return '-';
        }
        if (row.original.statusWiseCount.SUCCESS) {
          statusArray.push(`S: ${row.original.statusWiseCount.SUCCESS}`);
        }
        if (row.original.statusWiseCount.UPDATE_TRANSPORTER) {
          statusArray.push(
            `EWB: ${row.original.statusWiseCount.UPDATE_TRANSPORTER}`
          );
        }
        if (row.original.statusWiseCount.PARSING_SUCCESS) {
          statusArray.push(
            `P: ${row.original.statusWiseCount.PARSING_SUCCESS}`
          );
        }
        if (row.original.statusWiseCount.CONSIGNMENT_CREATED) {
          statusArray.push(
            `CN: ${row.original.statusWiseCount.CONSIGNMENT_CREATED}`
          );
        }
        if (row.original.statusWiseCount.FAILURE) {
          statusArray.push(`F: ${row.original.statusWiseCount.FAILURE}`);
        }
        if (row.original.statusWiseCount.RETRY_TRIGGERED) {
          statusArray.push(
            `R: ${row.original.statusWiseCount.RETRY_TRIGGERED}`
          );
        }
        let statusString =
          row.original.totalCount + '(' + statusArray.toString() + ')';

        return <div>{statusString}</div>;
      }
    },
    {
      Header: 'Actions',
      headerClassName: 'flex-12 zt-custom-th',
      className: 'flex-12',
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.BULK_CN_USING_EXCEL.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No data found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const bulkCnUsingExcelActionConfig = {
  buttons: [
    {
      label: 'Print Barcode Labels',
      labelOnly: true,
      hide: rowData =>
        !(
          rowData &&
          rowData.statusWiseCount &&
          rowData.statusWiseCount.SUCCESS
        ),
      onClick: rowData => {
        if (
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions &&
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.printBarcodeLabels
        ) {
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.printBarcodeLabels(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'Request File Download',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions &&
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.downloadRequestFile
        ) {
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.downloadRequestFile(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'Response File Download',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions &&
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions
            .downloadResponseFile
        ) {
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.downloadResponseFile(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'Download CN copies',
      labelOnly: true,
      hide: rowData =>
        !(
          rowData &&
          rowData.statusWiseCount &&
          rowData.statusWiseCount.SUCCESS
        ),
      onClick: rowData => {
        if (
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions &&
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.downloadCnCopies
        ) {
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.downloadCnCopies(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'Retry Failed CNs',
      labelOnly: true,
      hide: rowData =>
        !(
          rowData &&
          rowData.statusWiseCount &&
          rowData.statusWiseCount.FAILURE
        ),
      onClick: rowData => {
        if (
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions &&
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.retryFailedCns
        ) {
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.retryFailedCns(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'Create Dummy PRS',
      labelOnly: true,
      hide: (rowData, userProfile) => {
        return (
          (rowData &&
            rowData.statusWiseCount &&
            (rowData.statusWiseCount.PARSING_SUCCESS ||
              rowData.statusWiseCount.UPDATE_TRANSPORTER ||
              rowData.statusWiseCount.CONSIGNMENT_CREATED ||
              rowData.statusWiseCount.RETRY_TRIGGERED)) ||
          (userProfile &&
            userProfile.authorities &&
            userProfile.authorities.indexOf('ROLE_CAN_CREATE_PARTIAL_PRS') ===
              -1)
        );
      },
      onClick: rowData => {
        if (
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions &&
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions
            .createPartialDummyPrs
        ) {
          zoomTableActionsConfig.BULK_CN_USING_EXCEL.actions.createPartialDummyPrs(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    }
  ]
};

export const preBookCnsTableConfig = {
  columns: [
    {
      Header: 'Cnote',
      headerClassName: 'zt-custom-th flex-25',
      className: 'zt-custom-td flex-25',
      accessor: 'cnote',
      Cell: row => (
        <div className="l-row a-center">{row.original.cnote || '-'}</div>
      )
    },
    {
      Header: 'Client Code',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      Cell: row => row.original.clientCode || '-'
    },
    {
      Header: 'Booking Date',
      headerClassName: 'flex-15 zt-custom-th',
      className: 'zt-custom-td flex-15',
      Cell: row => {
        return (
          <div>
            {row.original.bookingTimeStamp
              ? getFormattedDateAndTime(row.original.bookingTimeStamp)
              : '-'}
          </div>
        );
      }
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No data found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

/**
 * isOrganisationRivigo: To check if selected organisation is Rivigo or not
 *
 * @param orgCode
 * @returns {boolean}
 */
export const isOrganisationRivigo = orgCode =>
  orgCode === 'RIVIGO' || orgCode === 'GLOBAL';

export const ORGANISATION_CODE_RIVIGO = 'RIVIGO';

export const USER_TYPE_RIVIGO = 'RIVIGO';
export const USER_TYPE_CLIENT = 'CLIENT';
export const USER_TYPE_BF = 'BF';

export const BF_TERMINAL = 'BF_TERMINAL';

export const preBookCnsDownloadHeaders = [
  { key: 'cnote', Header: 'Cnote' },
  { key: 'clientCode', Header: 'Client Code' },
  { key: 'bookingTimeStamp', Header: 'Booking Date' }
];
